import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Button } from '@amzn/awsui-components-react';
import img from '../../../assets/robot.svg.js';
import styles from '../styles/chatbot.module.scss.js';
import { useClient } from '../../../client/ClientProvider.js';
import { useState, useEffect } from 'react';

const MaintenancePage = () => {
    // By put checkServiceStatus in the context, we avoid props drilling, we can directly change the isHealthy from anywhere in the component tree
    const { checkServiceStatus } = useClient();
    // State to hold last checked time
    const [lastCheckedTime, setLastCheckedTime] = useState('');
    // Function to format date object into a readable string
    const getFormattedTime = (date) => {
        return date.toLocaleString();
    };
    // Function to handle refresh click
    const handleRefreshClick = () => __awaiter(void 0, void 0, void 0, function* () {
        yield checkServiceStatus();
        setLastCheckedTime(getFormattedTime(new Date()));
    });
    // On component mount, set the initial last checked time
    useEffect(() => {
        setLastCheckedTime(getFormattedTime(new Date()));
    }, []);
    return (jsxs("div", { className: styles['maintenance-page'], id: 'maintenancePage', "data-testid": 'maintenancePage', children: [jsx("img", { src: img, className: styles['robot-icon'], alt: 'Robot icon indicating maintenance mode' }), jsx("header", { children: jsx("h3", { children: "We're experiencing an issue" }) }), jsxs("section", { children: [jsx("p", { children: "The assistant is currently undergoing maintenance. Please try refreshing the page or restarting the assistant." }), jsxs("p", { children: ["Last checked: ", lastCheckedTime] })] }), jsx(Button, { ariaLabel: 'Refresh ths page', iconName: 'refresh', onClick: handleRefreshClick, children: "Refresh" })] }));
};

export { MaintenancePage as default };
